import { Paper, SimpleGrid, Stack, Text } from '@mantine/core';
import { useParams } from 'react-router-dom';
import PreviousPageButton from '#/components/ui/PreviousPageButton';
import { getResponseStatus } from '#/service/driver-management/utils/apiError.ts';
import { AccountDetailSection } from '../components/AccountDetailSection.tsx';
import { AccountSubscriptionsSection } from '../components/AccountSubscriptionsSection.tsx';
import { AutoPaySection } from '../components/AutoPaySection.tsx';
import { DocumentCard } from '../components/DocumentCard.tsx';
import { InsuranceSection } from '../components/InsuranceSection.tsx';
import { PointLinkSection } from '../components/PointLinkSection.tsx';
import { useAccountByIdData } from '../hooks/useAccountData.ts';

const BackToList = () => (
  <PreviousPageButton
    href="/driver-management/drivers"
    content="返回駕駛人列表"
  />
);

const AccountNotFound = () => (
  <div>
    <BackToList />
    <Paper radius="lg" p="xl" shadow="xs">
      <Text c="dimmed">查無此帳號</Text>
    </Paper>
  </div>
);

const DriverAccountDetail = ({ accountId }: { accountId: string }) => {
  const { error } = useAccountByIdData(accountId);
  if (getResponseStatus(error) === 404) return <AccountNotFound />;

  return (
    <div>
      <BackToList />
      <Stack gap="md" align="stretch">
        <AccountDetailSection accountId={accountId} />
        <AccountSubscriptionsSection accountId={accountId} />
        <SimpleGrid cols={{ base: 1, md: 2 }}>
          <DocumentCard accountId={accountId} documentType="DRIVING_LICENSE" />
          <DocumentCard
            accountId={accountId}
            documentType="VEHICLE_REGISTRATION"
          />
        </SimpleGrid>
        <InsuranceSection accountId={accountId} />
        <AutoPaySection accountId={accountId} />
        <PointLinkSection accountId={accountId} />
      </Stack>
    </div>
  );
};

const DriverAccountDetailPage = () => {
  const { id } = useParams();

  if (!id) return <AccountNotFound />;

  return <DriverAccountDetail accountId={id} />;
};

export default DriverAccountDetailPage;
